import { useQuery, useMutation } from "react-query";
import {
	getAllUsers_api,
	getUserDetails_api,
	updateUser_api,
	blockUser_api,
	unblockUser_api,
	downloadUsers_api,
	getOrderByUser_api,
	getReferredUsers,
	getNotOnboardedUsers,
	saveUserInfo,
	updateUserCredentials,
	getAllReferrals,
} from "../services/users";

export const useGetAllUsers = (params) =>
	useQuery(["getAllUsers", params], () => getAllUsers_api(params));

export const useGetAllReferrals = (params) =>
	useQuery(["getAllReferrals", params], () => getAllReferrals(params));

export const useGetUserDetails = (params) =>
	useQuery(["getUserDetails", params], () => getUserDetails_api(params));

export const useUpdateUser = () =>
	useMutation("updateUser", (id) => updateUser_api(id));

export const useBlockUser = () =>
	useMutation("blockUser", (id) => blockUser_api(id));

export const useUnblockUser = () =>
	useMutation("unblockUser", (id) => unblockUser_api(id));

export const useDownloadUsers = () =>
	useMutation("downloadUsers", (payload) => downloadUsers_api(payload));

export const useGetOrderByUser = (id) =>
	useQuery(["getOrderByUser", id], () => getOrderByUser_api(id));

export const useGetReferredUser = (payload) =>
	useQuery(["getReferredUser", payload], () => getReferredUsers(payload));

export const useGetNotOnboardedUsers = (payload) =>
	useQuery(["GetNotOnboardedUsers", payload], () =>
		getNotOnboardedUsers(payload)
	);

export const useSaveUserInfo = () =>
	useMutation("saveReferralCode", (payload) => saveUserInfo(payload));

export const useUpdateUserCredentials = () =>
	useMutation("updateUserCredentials", (payload) =>
		updateUserCredentials(payload)
	);
